<template>
    <div class="show-copy-feed-url">
        <div class="text-container">
            <slot />
        </div>

        <div class="feed-container">
            <label class="feed-url-label">Your RSS Feed URL:</label>

            <div class="feed-url-container">
                <input
                    class="feed-url-input"
                    :value="show.feedUrl"
                    readonly
                >

                <button
                    type="button"
                    class="feed-url-copy-button"
                    @click.prevent="copyUrl"
                >
                    <i class="far fa-copy feed-url-copy-icon" />
                    Copy
                </button>
            </div>
        </div>

        <div class="primary-action-container">
            <base-form-button
                class="btn"
                :has-arrow="true"
                @click.native.prevent="$emit('change-step-next')"
            >
                {{ nextStepButton }}
            </base-form-button>
        </div>

        <div class="secondary-action-container">
            <a href="#" class="previous-action" @click.prevent="$emit('change-step-prev')">
                Go back
            </a>
        </div>
    </div>
</template>
<script>
import toasts from '@/mixins/toasts';
import { writeToClipboard } from '@/utils/clipboard';

export default {
    mixins: [
        toasts,
    ],

    props: {
        show: {
            type: [Boolean, Object],
            default: () => ({}),
        },
        nextStepButton: {
            type: String,
            default: 'Continue',
        },
    },

    methods: {
        /**
         * Copies feed URL to clipboard.
         */
        async copyUrl() {
            await writeToClipboard(this.show.feedUrl);

            this.toastSuccess({ message: { title: 'URL copied to clipboard.' } });
        },
    },
};
</script>
